export const PriceEstimationMenuIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '20'}
    fill={'none'}
    viewBox="0 0 19 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8129 3.51593C10.8139 2.49278 8.72756 1.66406 6.15693 1.66406C3.5863 1.66406 1.50186 2.4937 1.5 3.51593M1.5 3.51593C1.5 4.53909 3.58444 5.36781 6.15693 5.36781C8.72942 5.36781 10.8139 4.53909 10.8139 3.51593L10.8139 10.7011M1.5 3.51593V14.6271C1.50093 15.6503 3.58537 16.479 6.15693 16.479C7.40406 16.479 8.5301 16.2817 9.36556 15.9641M1.50093 7.21966C1.50093 8.24282 3.58538 9.07153 6.15787 9.07153C8.73036 9.07153 10.8148 8.24282 10.8148 7.21966M9.42144 12.2429C8.58133 12.5716 7.42921 12.7753 6.15693 12.7753C3.58537 12.7753 1.50093 11.9466 1.50093 10.9235M16.106 11.2179C17.7424 12.8448 17.7424 15.4837 16.106 17.1106C14.4696 18.7374 11.8151 18.7374 10.1787 17.1106C8.54221 15.4837 8.54221 12.8448 10.1787 11.2179C11.8151 9.59106 14.4696 9.59106 16.106 11.2179Z"
      stroke={props?.color || '#101828'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
